import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { postRequest, postRequestWithParams } from "services/api";

const AddRoleData = () => {
  const [value, setValue] = useState("");
  const { user } = useSelector((state) => state.user);
  const [clientLists, setClientLists] = React.useState([]);
  const [disabled, setDisabled] = useState(false);
  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    setDisabled(true);
    let headers = {
      "Content-Type": "application/json;",
      Authorization: `Bearer ${user.token}`,
    };
    let payload = {};

    let params = {
      RoleName: value,
    };
    const response = await postRequestWithParams(
      "Admin/AddRole",
      payload,
      headers,
      params
    );

    window.location.reload();
  };

  useEffect(() => {
    getClientLists();
  }, []);

  const getClientLists = async () => {
    let headers = {
      "Content-Type": "application/json;",
      Authorization: `Bearer ${user.token}`,
    };
    let payload = {
      masterListFor: "roles",
      whseCode: "",
    };
    const response = await postRequest(
      "user/Get_MasListVals",
      payload,
      headers
    );

    setClientLists(response.data.Payload.Table);
  };

  return (
    <div>
      <Card>
        <CardContent>
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{ display: "flex", gap: 1 }}
          >
            <FormControl sx={{ width: "100%" }}>
            
              <TextField
                variant="outlined"
                placeholder="Enter Role"
                onChange={(e) => setValue(e.target.value)}
                value={value}
                fullWidth
              />
            </FormControl>
            <Button type="submit" variant="contained" disabled={disabled}>
              Submit
            </Button>
          </Box>
        </CardContent>
      </Card>

      <Box sx={{ pt: 4 }}>
        <Typography variant="h5" gutterBottom>
          Role List
        </Typography>

        <Grid container spacing={2}>
          {clientLists.map((client) => (
            <Grid item xs={12} sm={6} md={4} key={client.id}>
              <Card sx={{ height: 100 }}>
                <CardContent>
                  <Typography variant="h6">{client.text}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </div>
  );
};

export default AddRoleData;
